import MicPopUp from './MicPopUp.vue';
import MicPopUpList from './MicPopUpList.vue';
export default {
  MicPopUp,
  MicPopUpList,
};
